import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SimulationFieldsService implements AbstractCRUDService, OnDestroy {
	readonly id: EntityField = {
		id: 0,
		name: 'simulation.id',
		variable: 'id',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly status: EntityField = {
		id: 1,
		name: 'simulation.status',
		variable: 'status',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: []
	};
	readonly dippingRule: EntityField = {
		id: 2,
		name: 'simulation.dipping_rule',
		variable: 'dippingRule',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: []
	};
	readonly author: EntityField = {
		id: 3,
		name: 'gl.author',
		variable: 'author',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: []
	};
	readonly created: EntityField = {
		id: 4,
		name: 'simulation.created',
		variable: 'createdAt',
		type: InputComplexType.DATE_RANGE,
		filterType: FilterType.BETWEEN,
		required: false,
	};
	readonly prefix: EntityField = {
		id: 5,
		name: 'simulation.prefix',
		variable: 'prefix',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT,
	};
	readonly senderId: EntityField = {
		id: 6,
		name: 'simulation.sender_id',
		variable: 'senderId',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT,
	};
	readonly productName: EntityField = {
		id: 7,
		name: 'simulation.product_name',
		variable: 'productName',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: []
	};

	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [this.id, this.status, this.prefix, this.senderId, this.productName, this.dippingRule, this.author, this.created];

	constructor() {}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
	}

	create(): Observable<void> {
		return of();
	}

	update(): Observable<void> {
		return of();
	}

	delete(): Observable<void> {
		return of();
	}
}
